import { Info } from '@ui/components/icons';
import { TextTooltip } from '@ui/components/TextTooltip';
import { Icon } from '@ui/lib/park/ui/icon';
import { Table } from '@ui/lib/park/ui/table';
import { Text } from '@ui/lib/park/ui/text';
import { Trans, useTranslation } from 'next-i18next';
import { Box, BoxProps, HStack, VStack } from 'styled-system/jsx';

export const MassiveTokenHead = () => {
  return (
    <Table.Head position="sticky" top={0} zIndex={1}>
      <TableHeadRow />
    </Table.Head>
  );
};

const TableHeadRow = () => {
  const { t } = useTranslation();

  return (
    <Table.Row bg="black.lv1">
      <Table.Header />
      <Table.Header pl="20px" pr="20px">
        {t('common.ASSET')}
      </Table.Header>
      <Table.Header>
        <Text>{t('common.PRICE')}</Text>
      </Table.Header>
      <Table.Header minW="90px">
        <Text>{t('common.24H CHG')}</Text>
      </Table.Header>
      <Table.Header minW="90px">
        <Text>{t('common.24H. VOL.')}</Text>
      </Table.Header>
      <Table.Header minW="150px">
        <HStack
          gap={1}
          justifyContent="flex-start"
          _hover={{
            cursor: 'pointer',
          }}
        >
          {t('common.FUNDING(L/S)')}
        </HStack>
      </Table.Header>
      <Table.Header minW="150px">
        <HStack
          gap={1}
          justifyContent="flex-start"
          _hover={{
            cursor: 'pointer',
          }}
        >
          {t('common.OI(L/S)')}
        </HStack>
      </Table.Header>
    </Table.Row>
  );
};
